import { Route, Routes } from "react-router-dom";
import { NsuRegister } from "./list";
import { ConciliationErrorBoundary } from "@/components/conciliation-error-boundary";

export default function RegisterEvidenceNsuRoute() {
  return (
    <ConciliationErrorBoundary screen="nsu-register">
      <Routes>
        <Route path="/" element={<NsuRegister />} />
      </Routes>
    </ConciliationErrorBoundary>
  );
}
